import { FocusEvent } from 'react';
import { FiGlobe } from '@react-icons/all-files/fi/FiGlobe';
import { Input, InputProps } from './Input';

const onBlur = (e: FocusEvent<HTMLInputElement>) => {
  const websiteUrl = e.currentTarget.value;
  const isWebsiteFormatted =
    websiteUrl.startsWith('http://') || websiteUrl.startsWith('https://');

  e.currentTarget.value = websiteUrl.trim();

  if (!isWebsiteFormatted && websiteUrl.length) {
    e.currentTarget.value = `http://${e.currentTarget.value}`;
  }
};

export function WebsiteInput(props: InputProps) {
  return <Input {...props} leftIcon={FiGlobe} onBlur={onBlur} />;
}
